const relativeFormatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

const isSentinelDate = (d: Date): boolean => d.getFullYear() >= 9999;

export const formatDate = (value?: string): string => {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d.getTime()) || isSentinelDate(d)) return '—';
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' }).format(d);
};

export const formatDateTime = (value?: string): string => {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d.getTime()) || isSentinelDate(d)) return '—';
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short' }).format(d);
};

export const addDays = (date: Date, days: number): Date => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};

export const fromNow = (value?: string): string => {
  if (!value) {
    return '—';
  }

  const deltaMinutes = Math.round((new Date(value).getTime() - Date.now()) / (1000 * 60));
  if (Math.abs(deltaMinutes) < 60) {
    return relativeFormatter.format(deltaMinutes, 'minute');
  }

  const deltaHours = Math.round(deltaMinutes / 60);
  if (Math.abs(deltaHours) < 24) {
    return relativeFormatter.format(deltaHours, 'hour');
  }

  return relativeFormatter.format(Math.round(deltaHours / 24), 'day');
};

export const isExpiringWithinDays = (value: string | undefined, days: number): boolean => {
  if (!value) return false;
  const d = new Date(value);
  if (isNaN(d.getTime()) || isSentinelDate(d)) return false;
  return d.getTime() <= addDays(new Date(), days).getTime();
};
